import React from "react";
import { useCSVDownloader, useCSVReader } from "react-papaparse";
import { useEnumStrings } from "../enumStrings";
export interface DeleteButtonProps {
  dataToExportAsCSV?: any[];
  setDataAfterCSVImport: (data: any[]) => void;
}

function CSVButtons({
  dataToExportAsCSV,
  setDataAfterCSVImport,
}: DeleteButtonProps) {
  const { CSVDownloader, Type } = useCSVDownloader();
  const { CSVReader } = useCSVReader();

  const enumStrings = useEnumStrings();

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "row",
        justifyContent: "center",
        marginTop: "10px",
        marginBottom: "10px",
      }}
    >
      {dataToExportAsCSV && (
        <>
          <CSVDownloader
            type={Type.Link}
            bom={true}
            filename={"PrivateEmails_Export.csv"}
            data={dataToExportAsCSV}
            style={{
              cursor: "pointer",
              backgroundColor: "#E1A731",
              fontWeight: "bold",
              color: "white",
              borderRadius: "10px",
              borderWidth: "0px",
              boxShadow: "black 0px 4px 8px -7px",
              width: "150px",
              height: "35px",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            {enumStrings.exportCSV}
          </CSVDownloader>
          <div style={{ width: "20px" }} />
        </>
      )}

      <div
        style={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <CSVReader
          onUploadAccepted={(results: any) => {
            setDataAfterCSVImport(results);
          }}
        >
          {({ getRootProps, acceptedFile, ProgressBar }: any) => (
            <>
              <button
                type="button"
                style={{
                  cursor: "pointer",
                  backgroundColor: "#E1A731",
                  fontWeight: "bold",
                  color: "white",
                  borderRadius: "10px",
                  borderWidth: "0px",
                  boxShadow: "black 0px 4px 8px -7px",
                  width: "150px",
                  height: "35px",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  marginBottom: "5px",
                }}
                {...getRootProps()}
              >
                Import CSV
              </button>
              <ProgressBar />
            </>
          )}
        </CSVReader>

      </div>
    </div>
  );
}

export default CSVButtons;
